import { Link } from "react-router-dom";
import PricingNavLink from "./PricingNavLink";
let logo = require("assets/images/sportswear-erp.png");

function Nav() {
  return (
    <nav className="navbar navbar-expand-lg py-lg-3 navbar-dark">
      <div className="container">
        <a href="/" className="navbar-brand me-lg-5">
          <img
            src={logo}
            alt="Sportswear ERP Logo"
            className="logo-dark"
            height="60"
          />
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i className="mdi mdi-menu"></i>
        </button>

        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <ul className="navbar-nav me-auto align-items-center">
            <li className="nav-item mx-lg-1">
              <Link className="nav-link active" to="/">
                Home
              </Link>
            </li>
            <li className="nav-item mx-lg-1">
              <Link className="nav-link" to="/features">
                Features
              </Link>
            </li>

            <li className="nav-item mx-lg-1">
              <Link className="nav-link" to="/faqs">
                FAQs
              </Link>
            </li>

            <li className="nav-item mx-lg-1">
              <Link className="nav-link" to="/contact-us">
                Contact
              </Link>
            </li>
            <li className="nav-item mx-lg-1">
              <PricingNavLink>Pricing</PricingNavLink>
            </li>
          </ul>

          <ul className="d-none navbar-nav ms-auto align-items-center">
            <li className="nav-item me-0">
              <Link to="/app/client-login" className="nav-link d-lg-none">
                Log In
              </Link>
              <Link
                to="/app/client-login"
                className="btn btn-sm btn-light rounded-pill d-none d-lg-inline-flex"
              >
                <i className="mdi mdi-login me-2"></i> Log In
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Nav;
